module.exports = __webpack_public_path__ + "img/QRScan.4dcb30ce.jpg";